export const PAGE_CREATION_LOGIN_QUERY_PARAM = 'pageCreationLogin';

export const trackingEvents = {
  loggedInViaPageCreation: 'user_logged_in_via_page_creation',
  nextButtonClicked: 'interstitial_next_button_click',
  startFundraisingSummaryNextButtonClicked:
    'start_fundraising_summary_next_button_click',
};
